import { useEffect, useState } from 'react';
import { get } from '../../Utilities';
import { getClientId, getClientUserId } from '../../redux/reducers/clientUserId.reducer';
import { connect } from 'react-redux';
import './UserStats.scss';

const gradientSet1 = {
  0: 'linear-gradient(135deg, #FFEEDB 0%, #FFDDB0 100%)',
  1: 'linear-gradient(135deg, #FFFFFF 0%, #FEF2E5 100%)',
  2: 'linear-gradient(135deg, #FFF8F3 0%, #F8ECDF 100%)',
  3: 'linear-gradient(135deg, #FEF2E5 0%, #F2E6DA 100%)',
  4: 'linear-gradient(135deg, #F8ECDF 0%, #EDE1D4 100%)',
  5: 'linear-gradient(135deg, #F7EFEA 0%, #E8E1DC 100%)',
  6: 'linear-gradient(135deg, #FFF8F3 0%, #FFDDB0 100%)',
  7: 'linear-gradient(135deg, #FFFBFF 0%, #FFEEDB 100%)',
  8: 'linear-gradient(135deg, #FFDDB0 0%, #F2BE6E 100%)',
  9: 'linear-gradient(135deg, #FFFFFF 0%, #FFDDB0 100%)',
};

const gradientSet2 = {
  0: 'linear-gradient(135deg, #FFF8F3 0%, #FFDAD6 100%)',
  1: 'linear-gradient(135deg, #FFF8F3 0%, #F9DEBB 100%)',
  2: 'linear-gradient(135deg, #FFEEDB 0%, #F3E0C9 100%)',
  3: 'linear-gradient(135deg, #F9DEBB 0%, #DCC3A1 100%)',
  4: 'linear-gradient(135deg, #EFE0CF 0%, #D2C4B4 100%)',
  5: 'linear-gradient(135deg, #FFF8F3 0%, #D2EABD 100%)',
  6: 'linear-gradient(135deg, #F8FFEB 0%, #E7F6D7 100%)',
  7: 'linear-gradient(135deg, #D2EABD 0%, #B6CEA2 100%)',
  8: 'linear-gradient(135deg, #FFDDB0 0%, #D2EABD 100%)',
  9: 'linear-gradient(135deg, #F9DEBB 0%, #D2EABD 100%)',
};

function getGradient(id, set = 1) {
  const lastDigit = Number(String(id).slice(-1));

  if (Number.isNaN(lastDigit)) {
    return gradientSet1[0]; // fallback
  }

  return set === 1 ? gradientSet1[lastDigit] : gradientSet2[lastDigit];
}

function getInitials(text = '') {
  const words = text.trim().split(/\s+/).filter(Boolean);

  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }

  return '';
}

const MulyankanDash = (props) => {
  const { clientUserId, clientId, history } = props;

  const [foldersArray, setFoldersArray] = useState([]);

  useEffect(() => {
    get(
      { client_user_id: clientUserId, client_id: clientId, d: Date.now() },
      '/getDashboardFolderHierarchyMulyankan',
    ).then((res) => {
      if (res && res.success) {
        setFoldersArray(res.result?.primary_folders || []);
      }
    });
  }, []);

  const goToFolder = (folder) => {
    history.push({ pathname: `/folder/${folder.folder_id}` });
  };

  return (
    <div className='MulyankanDash__container'>
      {foldersArray.length>0 && clientId == 2050 && <p className='fontBold20 d-flex align-items-center px-3 px-md-4'>Free Videos <span className='p-1 mx-2' style={{background: '#35a91f', color: 'white', borderRadius: '5px', fontSize: '12px', fontFamily: 'Montserrat-Regular' }}>New</span></p>}
      {/* Create Exam Paper Section */}
      {foldersArray.length > 0 &&
        foldersArray.map((primaryFolder, mainIndex) => (
          <div className='MulyankanDash__section mb-0' key={primaryFolder.folder_id}>
            <div className='MulyankanDash__header'>
              {clientId == 2002 && <p className='MulyankanDash__title d-flex align-items-center px-3 px-md-0'>{primaryFolder.folder_name}</p>}
            </div>

            <div className='MulyankanDash__scroll-container'>
              <div className='MulyankanDash__cards-wrapper'>
                {primaryFolder.secondary_folders &&
                  primaryFolder.secondary_folders.map((secondary, index) => (
                    <div
                      role='button'
                      key={secondary.folder_id}
                      onClick={() => goToFolder(secondary)}
                      className='MulyankanDash__exam-card ml-3 ml-md-0'
                    >
                      {secondary.thumbnail ? (
                        <div
                          className='MulyankanDash__card-thumbnail'
                          style={{
                            backgroundImage: `url(${secondary.thumbnail})`,
                            borderRadius: mainIndex % 2 === 0 ? '12px' : '100px',
                          }}
                        >
                          <div className='MulyankanDash__logo-overlay'>
                            <div className='MulyankanDash__cbse-logo'></div>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            background: getGradient(secondary.folder_id, index % 2 === 0 ? 1 : 2),
                            borderRadius: mainIndex % 2 === 0 ? '12px' : '100px',
                          }}
                          className='MulyankanDash__card-image-wrapper'
                        >
                          <p className='MulyankanDash__initialstext'>
                            {getInitials(secondary.folder_name)}
                          </p>
                          <div className='MulyankanDash__logo-overlay'>
                            <div className='MulyankanDash__cbse-logo'></div>
                          </div>
                        </div>
                      )}

                      <div className='MulyankanDash__card-content'>
                        <h3 className='MulyankanDash__card-title'>{secondary.folder_name}</h3>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientId: getClientId(state),
  clientUserId: getClientUserId(state),
});

export default connect(mapStateToProps, null)(MulyankanDash);
